<ng-container header-content *ngIf="isCode">
  <div class="code-wrap flex flex-row gap-[16px]">
    <app-pill [type]="code === 0 ? pillType.successInverted : pillType.mediumInverted">
      {{ '+INSTALLATIONS.INSTALLATION.LECTURE_CODE_ADDRESS.TITLE' | translate }}
    </app-pill>
    <div data-at-description class="description">
      {{ getDescription() | translate }}
    </div>
  </div>
</ng-container>
